import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import http from './utils/https.js'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css';
import {
	formatTimeStamp
} from './utils/formatTimeStamp.js'
import Print from 'vue-print-nb'
Vue.use(Print);
Vue.use(ElementUI);

Vue.use({
	install(Vue) {
		Vue.prototype.$http = http
		// Vue.prototype.$formatTimeStamp = formatTimeStamp
	}
})
//获取当前时间
// 将以下代码添加至 main.js 或者任何全局可访问的地方

Vue.prototype.$getCurrentTime = function() {
	const date = new Date();
	const year = date.getFullYear();
	const month = ('0' + (date.getMonth() + 1)).slice(-2);
	const day = ('0' + date.getDate()).slice(-2);
	const hours = ('0' + date.getHours()).slice(-2);
	const minutes = ('0' + date.getMinutes()).slice(-2);
	const seconds = ('0' + date.getSeconds()).slice(-2);

	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
import 'video.js/dist/video-js.css'
Vue.prototype.$formatTimeStamp = formatTimeStamp
//cdn地址
Vue.prototype.$cdn = 'http://files.gsjtpxzx.com'
Vue.prototype.$https = 'https://zhicheng.gsjtpxzx.com'
Vue.prototype.$uploadApi = 'https://zhicheng.gsjtpxzx.com/api/common/upload'
Vue.config.productionTip = false
new Vue({
	router,
	el: '#app',
	render: h => h(App),
}).$mount('#app')
